<template lang="pug">
modal
	.card
		.card-header.bg-info.text-white
			span.fa.fa-picture.mr-2
			| Imágenes
			button.close(@click="cerrar") &times;
		.card-body.bg-light
			.input-group
				.input-group-prepend
					.input-group-text
						span.fa.fa-search
				input.form-control(v-model="filtro.cadena", @keypress.enter="buscar()", autofocus)
			div.text-left.mt-2(v-if="galerias.length > 0")
				h5 Galerías
				.imagenes.mt-2(v-if="galerias.length > 0")
					MiniGaleria(
						v-for="galeria in galerias"
						:key="galeria.GaleriaID"
						@selecciona="getGaleria($event)"
						:galeria="galeria"
					)
			div.text-left.mt-2(v-if="imagenes.length > 0")
				.imagenes.mt-2(v-if="imagenes.length > 0")
					div(
						v-for="imagen in imagenes"
						:key="imagen.ItemID"
						:style="imagen.estilo"
						@click="selecciona(imagen.ItemID)"
						:class="(seleccion.indexOf(imagen.ItemID) >= 0) ? 'seleccionada' : ''"
					)
			div.mt-2.text-center.text-danger(v-if="buscado && imagenes.length === 0 && galerias.length === 0", style="font-weight:bold;")
				h3
					span.fa.fa-ban
					br
					| No hay resultados
		.card-footer
			button.btn.btn-primary(@click="adjuntar", :disabled="seleccion.length === 0")
				span.fa.fa-check.mr-2
				| Adjuntar
</template>

<script>
import MiniGaleria from '../../../../galerias/vue/componentes/listado-galerias/mini-galeria.vue'
import axios from 'axios'
export default {
	components: {
		MiniGaleria
	},
	data () {
		return {
			filtro: {
				cadena: ''
			},
			buscado: false,
			resultados: {
				items: [],
				galerias: []
			},
			seleccion: []
		}
	},
	computed: {
		imagenes () {
			return this.resultados.items.map(i => {
				i.estilo = {
					'background-image': 'url("src/modulos/galerias/php/api/thumb.php?ItemID=' + i.ItemID + '")'
				}
				return i
			})
		},
		galerias () {
			return this.resultados.galerias.map(g => {
				g.estilo = {
					'background-image': 'url("src/modulos/galerias/php/api/thumb.php?ItemID=' + g.PortadaID + '")'
				}
				return g
			})
		}
	},
	methods: {
		getGaleria (GaleriaID) {
			axios.post('galerias/php/api/get-galeria.php', {GaleriaID: GaleriaID})
				.then(res => {
					this.resultados.galerias = []
					this.resultados.items = res.data.galeria.items
				})
				.catch(this.$responseError)
		},
		buscar () {
			axios.post('galerias/php/api/buscador.php', {cadena: this.filtro.cadena})
				.then(res => {
					this.resultados = res.data
					this.buscado = true
				})
				.catch(this.$responseError)
		},
		selecciona (ItemID) {
			if (this.seleccion.indexOf(ItemID) < 0) {
				this.seleccion.push(ItemID)
			} else {
				this.seleccion.splice(this.seleccion.indexOf(ItemID), 1)
			}
		},
		adjuntar () {
			this.$emit('adjuntar', this.seleccion)
			this.cerrar()
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>
.imagenes {
	display: flex;
	position: relative;
	width: 100%;
	flex-direction: row;
	flex-wrap: wrap;
	align-content: flex-start;
	align-items: flex-start;
	align-self: stretch;
}

.imagenes > div {
	max-width: 200px;
	max-height: 200px;
	min-width: 200px;
	min-height: 200px;
	cursor: pointer;
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	padding: 2px;
	background-origin: content-box;
}

.seleccionada {
	opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/modulos/redaccion/vue/componentes/editor/buscadorImagenes.vue